import validate from "/www/wwwroot/FTS/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/www/wwwroot/FTS/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "admin-only": () => import("/www/wwwroot/FTS/middleware/admin-only.ts"),
  auth: () => import("/www/wwwroot/FTS/middleware/auth.ts"),
  guest: () => import("/www/wwwroot/FTS/middleware/guest.ts"),
  "user-only": () => import("/www/wwwroot/FTS/middleware/user-only.ts")
}